import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SystemUpdateBanner.css';

function SystemUpdateBanner() {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();

  // Define routes where the banner should never appear
  const hideOnRoutes = ['/resume', '/embed', '/admin'];
  const isExcludedRoute = hideOnRoutes.some(path => location.pathname.startsWith(path));

  // Dynamic version-based acknowledge key
  const versionKey = `devtracker_v4.3.1_slider_announcement`;

  useEffect(() => {
    const isAck = localStorage.getItem(versionKey);
    const shouldDisplay = isAck !== 'true' && !isExcludedRoute;

    if (shouldDisplay) {
      setVisible(true);
      document.body.classList.add('banner-active');
    } else {
      setVisible(false);
      document.body.classList.remove('banner-active');
    }
    
    return () => document.body.classList.remove('banner-active');
  }, [location.pathname, isExcludedRoute, versionKey]);

  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev === 0 ? 1 : 0));
    }, 6000); // Swap every 6 seconds
    return () => clearInterval(interval);
  }, [visible]);

  const handleAcknowledge = () => {
    localStorage.setItem(versionKey, 'true');
    setVisible(false);
    document.body.classList.remove('banner-active');
  };

  if (!visible) return null;

  return (
    <div className="system-update-banner animate-slide-down">
      <div className="banner-slider-container">
        
        {/* Slide 1: Dev-HUD Patch */}
        <div className={`banner-content banner-slide ${activeIndex === 0 ? 'active' : ''}`}>
          <div className="banner-ai-icon" style={{background: 'linear-gradient(135deg, #ffc01e 0%, #ff8c00 100%)', boxShadow: '0 0 20px rgba(255, 192, 30, 0.4)'}}>
            <i className="fa-solid fa-triangle-exclamation"></i>
          </div>
          <div className="banner-text">
            <span className="banner-badge" style={{color: '#ffc01e', borderColor: 'rgba(255, 192, 30, 0.2)', background: 'rgba(255, 192, 30, 0.1)'}}>DEV-HUD | SECURITY PATCH</span>
            <p>
              DevTracker v4.3.1 is Live! We've improved data extraction. <strong>Note: AI & Resume Mode are in active development (expect some bugs).</strong> Security Patch 4.3.0 is also deployed.
              <Link to="/changelog" className="banner-primary-link" onClick={handleAcknowledge}>Changelog</Link>
            </p>
          </div>
          <button className="banner-close" onClick={handleAcknowledge} title="Acknowledge">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        {/* Slide 2: BharatVerify */}
        <div className={`banner-content banner-slide ${activeIndex === 1 ? 'active' : ''}`}>
          <div className="banner-ai-icon">
            <i className="fa-solid fa-shield-halved"></i>
          </div>
          <div className="banner-text">
            <span className="banner-badge">SECURITY UPGRADE ANNOUNCEMENT 🚀</span>
            <p>
              <strong>DevTracker 🤝 BharatVerify:</strong> We’re strengthening DevTracker’s security with BharatVerify. 
              Thank you <strong>BharatVerify</strong> for supporting a safer developer platform.
              <Link to="/about" className="banner-primary-link" onClick={handleAcknowledge}> Read More</Link>
            </p>
          </div>
          <button className="banner-close" onClick={handleAcknowledge} title="Acknowledge">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

      </div>
      <div className="banner-progress-glow"></div>
    </div>
  );
}

export default SystemUpdateBanner;
